import React from 'react'

import './shared-button.scss'
import SharedWhatsapp from '../../../shared/components/atoms/shared-whatsapp/shared-whatsapp';
import SharedFacebook from '../../../shared/components/atoms/shared-facebook/shared-facebook';

const SharedButton = ({ mobile, zodiacSign }) => {
    const [activeShared, setActiveShared] = React.useState(false);
    // var news_info=props.dataProp
    return (
        <div className="f-Shared-button">
            {!activeShared && <div className="f-Shared-button-open" onClick={()=>setActiveShared(true)}>
                <span className="icon-share"></span> 
            </div>
            }
            {activeShared && <div className="f-Shared-button-close"> 
                <div className="f-Shared-button-close-hide" onClick={() => setActiveShared(false)}>
                    <span className="icon2-close"></span>  
                </div>
                <div className="f-Shared-button-close-icons">
                    <SharedFacebook zodiacSign={zodiacSign} href={window.location.href}>
                        <span className="icon-facebook"></span>
                    </SharedFacebook> 
                    <SharedWhatsapp zodiacSign={zodiacSign} href={mobile ? "whatsapp://send?text=" + window.location.href: "https://web.whatsapp.com/send?text=" + window.location.href} />
                </div>
            </div>}
        </div>
    )
}

export default SharedButton;
